var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-cpt":"core/ev-info"}},[_c('ul',{staticClass:"select-list clearfix"},_vm._l((_vm.selects),function(s,i){return _c('li',{key:i,staticClass:"select-item fl"},[(_vm.showName)?_c('span',[_vm._v(_vm._s(s.optionName)+":")]):_vm._e(),_vm._v("\n      "+_vm._s(s.optionValue)+"\n    ")])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-470650f0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/core/ev-info/selects.vue
// module id = null
// module chunks = 